import { InstallationStatus } from '../types'

export const canViewInstallationDeviceStatus = (isUser: boolean, isAllowedTheme: boolean, installationStatus?: InstallationStatus): boolean => {
  return !isUser && isAllowedTheme && installationStatus !== 'planned'
}
